export default requester => {
    return {
        /**
         * Get channels
         * 
         * @return {object}
         */
        list (platformSlug, params = {}) {
            return requester.get(`/content/management/${platformSlug}/channels`, { params });
        },

        /**
         * Get channel
         *
         * @param {*} platformSlug
         * @param {*} channelSlug
         * @return {object}
         */
        get (platformSlug, channelSlug) {
            return requester.get(`/content/management/${platformSlug}/channels/${channelSlug}`);
        },

        /**
         * Create channel
         * 
         * @param {*} payload 
         * @returns 
         */
        create (platformSlug, payload) {
            return requester.post(`/content/management/${platformSlug}/channels`, payload);
        },

        /**
         * Create channel
         * 
         * @param {*} payload 
         * @returns 
         */
        update (platformSlug, channelSlug, payload) {
            return requester.put(`/content/management/${platformSlug}/channels/${channelSlug}`, payload);
        },

        /**
         * Get channel
         * 
         * @param {*} platformSlug
         * @param {*} channelSlug
         * @returns
         **/
        invitation (platformSlug, token) {
            return requester.get(`/content/management/${platformSlug}/invites/${token}`);
        },

        /**
         * Join channel
         * 
         * @param {*} platformSlug
         * @param {*} token
         * @param {*} payload
         * @returns
         **/
        join (platformSlug, token, payload) {
            return requester.patch(`/content/management/${platformSlug}/invites/${token}`, payload);
        },

        /**
         * Get all members of a channel
         * 
         * @param {*} platformSlug 
         * @param {*} channelSlug 
         * @param {*} params 
         * @returns 
         */
        memberList (platformSlug, channelSlug, params = {}) {
            return requester.get(`/content/management/${platformSlug}/channels/${channelSlug}/members`, { params });
        },

        /**
         * Get all members metrics of a channel
         * 
         * @param {*} platformSlug 
         * @param {*} channelSlug 
         * @returns 
         */
        memberMetrics (platformSlug, channelSlug) {
            return requester.get(`/content/management/${platformSlug}/channels/${channelSlug}/members/meta`);
        },

        /**
         * Create a new signup for a channel
         * 
         * @param {*} platformSlug 
         * @param {*} payload 
         * @returns 
         */
        signupCreate (platformSlug, payload, config = {}) {
            return requester.post(`/content/channels/${platformSlug}/signup`, payload, config);
        },

        /**
         * Get all signups of a channel
         * 
         * @param {*} platformSlug 
         * @param {*} channelSlug 
         * @returns 
         */
        signupList (platformSlug, params) {
            return requester.get(`/content/channels/${platformSlug}/signup`, { params });
        },

        /**
         * Operate on a signup
         * 
         * @param {*} platformSlug
         * @param {*} signupId
         * @param {*} payload
         * @returns
         */
        signupOperate (platformSlug, signupId, payload) {
            return requester.patch(`/content/channels/${platformSlug}/signup/${signupId}`, payload);
        },

        /**
         * Update member
         * 
         * @param {*} platformSlug 
         * @param {*} channelSlug 
         * @param {*} memberId
         * @param {*} payload
         * @returns 
         */
        signupUpdate (platformSlug, signupId, payload) {
            return requester.put(`/content/channels/${platformSlug}/signup/${signupId}`, payload);
        },

        /**
         * Update members of a channel
         * 
         * @param {*} platformSlug 
         * @param {*} channelSlug 
         * @param {*} payload 
         * @returns 
         */
        updateMembers (platformSlug, channelSlug, payload) {
            return requester.post(`/content/management/${platformSlug}/channels/${channelSlug}/members`, payload);
        },

        /**
         * Send the invitation to join a channel
         * 
         * @param {*} platformSlug 
         * @param {*} channelSlug 
         * @returns 
         */
        invite (platformSlug, payload) {
            return requester.post(`/content/management/${platformSlug}/invites`, payload);
        },

        /**
         * Send the invitation preview to the user
         * 
         * @param {*} platformSlug 
         * @param {*} channelSlug 
         * @returns 
         */
        previewInvite (platformSlug, payload) {
            return requester.post(`/content/management/${platformSlug}/invites/preview`, payload);
        },

        /**
         * Create account
         * 
         * @param {*} payload 
         * @returns 
         */
        createAccount (payload) {
            return requester.post(`/account/signup/invite`, payload);
        },

        /**
         * Perform a channel member operation (join, leave, etc)
         * 
         * @param {string} platformSlug - Slug of the platform
         * @param {object} payload - Operation details, must include 'channel', 'op', 'data'
         * @return {object}
         */
        memberOperation(platformSlug, payload) {
            return requester.patch(`/content/channels/${platformSlug}/members`, payload);
        },

        /**
         * Check if a user is a member of a channel
         * 
         * @param {string} platformSlug - Slug of the platform
         * @param {string} channelSlug - Slug of the channel
         * @return {object}
         */
        memberStatus(platformSlug, channelSlug) {
            return new Promise((resolve, reject) => {
                resolve({
                    data: {
                        status: 'active'
                    }
                })
            });
        },

        /**
         * Subscribe to a channel
         * 
         * @param {*} platformSlug 
         * @param {*} channelSlug 
         * @returns 
         */
        subscribe (platformSlug, channelSlug, payload, config = {}) {
            return requester.post(`/content/channels/${platformSlug}/${channelSlug}/members`, payload, config);
        },

        /**
         * Get all subscriptions of the current user
         * 
         * @param {*} payload 
         * @returns 
         */
        subscriptions(payload) {
            return requester.get(`/content/me/members`, { params: payload });
        }
    };
}